import {
    noticeMessageStart,
    noticeMessageSuccess,
    noticeMessageGetAllSuccess,
    noticeMessageFailure,
    cleanNoticeMessage,
    noticeMessageDeleteSuccess,
} from '../reducers/noticeMessage';

import rawAxios from 'axios';
import { axiosPrivate } from '../../api/axios';

const uploadNoticeImage = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', process.env.REACT_APP_PRESET_NAME);
    formData.append('cloud_name', process.env.REACT_APP_CLOUD_NAME);
    formData.append('upload_preset', 'fca-intranet');

    // Cloudinary: sin interceptores ni credenciales de nuestra API.
    const res = await rawAxios.post(
        `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`,
        formData,
    );

    if (res.status !== 200) {
        throw new Error('No se pudo subir la imagen del aviso.');
    }

    return {
        urlName: res.data.secure_url,
        publicId: res.data.public_id,
    };
};

export const createNewNoticeMessage = (
    file,
    courseId,
    userId,
    message,
    link,
) => async (dispatch) => {
    dispatch(noticeMessageStart());
    try {
        let imagePayload = {};
        if (file) {
            imagePayload = await uploadNoticeImage(file);
        }

        const response = await axiosPrivate.post('/noticeMessage/createNewNoticeMessage', {
            ...imagePayload,
            userId,
            courseId,
            message,
            link,
        });

        if (response.status === 201) {
            dispatch(noticeMessageSuccess());
            return {
                status: response.status,
                message: response.data.message,
                data: response.data.data,
            };
        }

        dispatch(noticeMessageFailure());
        return {
            status: response.status,
            message: response.data?.message || 'No se pudo crear el aviso.',
        };
    } catch (error) {
        dispatch(noticeMessageFailure());
        return {
            status: error?.response?.status || 500,
            message: error?.response?.data?.message || 'No se pudo crear el aviso.',
        };
    }
};

export const updateNoticeMessage = (noticeId, {
    message,
    link,
    file,
    removeImage = false,
} = {}) => async (dispatch) => {
    dispatch(noticeMessageStart());
    try {
        const payload = {
            message,
            link,
            removeImage,
        };

        if (file) {
            const imagePayload = await uploadNoticeImage(file);
            Object.assign(payload, imagePayload);
        }

        const response = await axiosPrivate.patch(`/noticeMessage/updateNoticeMessage/${noticeId}`, payload);

        if (response.status === 200) {
            dispatch(noticeMessageSuccess());
            return {
                status: response.status,
                message: response.data.message,
                data: response.data.data,
            };
        }

        dispatch(noticeMessageFailure());
        return {
            status: response.status,
            message: response.data?.message || 'No se pudo actualizar el aviso.',
        };
    } catch (error) {
        dispatch(noticeMessageFailure());
        return {
            status: error?.response?.status || 500,
            message: error?.response?.data?.message || 'No se pudo actualizar el aviso.',
        };
    }
};

export const getNoticeMessages = (courseId) => async (dispatch) => {
    dispatch(noticeMessageStart());
    try {
        const response = await axiosPrivate.get(`/noticeMessage/getAllNoticeMessage/${courseId}`);
        if (response.status === 200) {
            dispatch(noticeMessageGetAllSuccess(response.data));
        }
        return response.data;
    } catch (error) {
        dispatch(noticeMessageFailure());
        return null;
    }
};

export const deleteNoticeMessages = (messaageMuroId) => async (dispatch) => {
    dispatch(noticeMessageStart());
    try {
        const response = await axiosPrivate.delete(`/noticeMessage/deleteNewNoticeMessage/${messaageMuroId}`);
        if (response.status === 200) {
            dispatch(noticeMessageDeleteSuccess(response.data));
            return {
                status: response?.status || null,
                message: response?.data.message,
            };
        }
        return {
            status: response.status,
            message: response.data?.message || 'No se pudo eliminar el aviso.',
        };
    } catch (error) {
        dispatch(noticeMessageFailure());
        return {
            status: error?.response?.status || 500,
            message: error?.response?.data?.message || 'No se pudo eliminar el aviso.',
        };
    }
};

export const cleanActionNoticeMessages = () => async (dispatch) => {
    dispatch(cleanNoticeMessage());
};
